$(document).foundation();

function initMobileMenuControls() {
	var items = $("#menu .l1-item").length;

	$("#menu .l1-item").on("click", function() {
		var itemCount = $(this).find(".sub-menu li").length;

		if (itemCount >= items) {
			$("#menu-wrap .menu-btm").css("transform", "translateY(" + (((itemCount + 1) - items) * 52).toString() + "px)");
		}
	});

	$(document).on("click", "#menu .l1-item .btn-close-sub", function() {
		$("#menu-wrap .menu-btm").css("transform", "none");
  });

  $("#header .mobile-menu-toggle").on("click", () => {
      $("#header .mobile-menu").toggleClass("open");
  });
}

$(function() {

    //---------------------------------------------------------
    //  Menu
    //---------------------------------------------------------
    $(document).on('click', '.btn-mobile-menu', function() {
        $(this).toggleClass('open');
        $('body').toggleClass('menu-open');
        $('#flyout-menu').toggleClass('open');
        $('#header').toggleClass('solid');
        return false;
    });

    $(document).on('click', '.link-parent-mobile', function() {
        $('.sub-menu').removeClass('mobile-open');
        $(this).parent().next('.sub-menu').addClass('mobile-open');
        $('#menu').addClass('sub-open');
        return false;
    });

    $(document).on('click', '.btn-close-sub', function() {
        $('.sub-menu').removeClass('mobile-open');
        $('#menu').removeClass('sub-open');
    });

	if (window.innerWidth < 700) initMobileMenuControls();
    //---------------------------------------------------------
    //---------------------------------------------------------
    //  Dropdown Navigation Menu
    //---------------------------------------------------------
    $('.top-menu-parent').mouseenter(function() {
        var navTray = $(this).find('.nav-tray');
        navTray.fadeIn(400);
    }).mouseleave(function(event) {
        var navTray = $(this).find('.nav-tray');
        navTray.fadeOut(250);
    });
    // $(document).on('click', '.top-menu-parent', function() {
    //     var navTray = $(this).find('.nav-tray');
    //     navTray.fadeIn(400);
    // });
    //
    // $('.top-menu-parent').mouseleave(function(event) {
    //     var navTray = $(this).find('.nav-tray');
    //     navTray.fadeOut(250);
    // });

    // window.onscroll = function() {
    //     $('.nav-tray').fadeOut(250);
    // }

    // //---------------------------------------------------------


    //---------------------------------------------------------
    //  Elements
    //---------------------------------------------------------
    if ($('.rellax').length > 0) {
        var rellax = new Rellax('.rellax', {});
    }

    if ($('.content-slider').length > 0) {
        $('.content-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:true,
            speed: 600,
            dots: true,
            appendDots: $('.content-slider-wrap'),
            appendArrows: $('.content-slider-wrap'),
            prevArrow:'<a class="slider-prev"><i class="fal fa-arrow-left"></i></i></a>',
            nextArrow:'<a class="slider-next"><i class="fal fa-arrow-right"></i></i></a>',
            responsive: [
              {
                breakpoint: 500,
                settings: {
                    arrows: false
                }
              },
            ]
        });
    }

    if ($('.image-carousel').length > 0) {
        $('.image-carousel').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:true,
            speed: 600,
            dots: false,
            appendArrows: $('.image-carousel-wrap'),
            prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
            nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
            responsive: [
              {
                breakpoint: 500,
                settings: {
                    arrows: false
                }
              },
            ]
        });
    }

    if ($('.stacked-image-carousel').length > 0) {
        $('.stacked-image-carousel').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:false,
            speed: 600,
            dots: false,
            appendArrows: $('.stacked-image-carousel-wrap'),
            prevArrow:'<a class="slider-prev"></a>',
            nextArrow:'<a class="slider-next"></a>',
            // responsive: [
            //   {
            //     breakpoint: 500,
            //     settings: {
            //         arrows: false
            //     }
            //   },
            // ]
        });
    }

    if ($('.tile-slider').length > 0) {
        $(".tile-slider").each(function(index, element) {
            $(this).slick({
                infinite: true,
                slidesToShow: $(this).data("count"),
                slidesToScroll: 1,
                autoplay:true,
                speed: 600,
                dots: false,
                appendArrows: $('.tile-grid-wrap'),
                prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
                nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
                responsive: [
                  {
                    breakpoint: 500,
                    settings: {
                        arrows: false
                    }
                  },
                ]
            });
       });
    }
    //---------------------------------------------------------


    //---------------------------------------------------------
    //  Dropdown Navigation Menu
    //---------------------------------------------------------
    $(document).on('click', '.icon-menu', function() {
        $(this).toggleClass('open');
        $('#dropdown-menu').toggleClass('open');
        $('#header').toggleClass('menu-open');
        $('body').toggleClass('menu-open');
        if ($(this).hasClass('open')) {
            $('#nav-shade').fadeIn(300);
        } else {
            $('#nav-shade').fadeOut(300);
        }
    });

    $(document).on('click', '.sub-menu-expand', function() {
        $(this).toggleClass('open');
        $(this).parent().find('.sub-menu').toggleClass('open');
    });
    //---------------------------------------------------------


    $(document).on('click', '.gallery-list', function() {
        $(".gallery-list").removeClass('active')
        $(this).addClass('active');
        $(".gallery-content").removeClass('active')
        $("#gallery-content-"+$(this).data('id')).addClass('active')
        $(".featured-treatment").removeClass('active')
        $("#featured-treatment-"+$(this).data('id')).addClass('active')

        $('.gallery-rotator').slick('unslick');
        $(".gallery-rotator").each(function(index, element) {
            console.log('asdf');
            $(this).slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay:false,
                speed: 600,
                dots: true,
                appendDots: $(this).parent(),
                appendArrows: $(this).parent(),
                prevArrow:'<a class="slider-prev"><i class="fal fa-arrow-left"></i></i></a>',
                nextArrow:'<a class="slider-next"><i class="fal fa-arrow-right"></i></i></a>',
                responsive: [
                  {
                    breakpoint: 500,
                    settings: {
                        arrows: false
                    }
                  },
                ]
            });
       });

    });


    $(document).on('click', '.treatment-video-link', function() {
        $(".treatment-videos").hide();
        $("#treatment-videos-"+$(this).data('id')).show();
    });


    if ($('.gallery-rotator').length > 0) {
        $(".gallery-rotator").each(function(index, element) {
            $(this).slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay:false,
                speed: 600,
                dots: true,
                appendDots: $(this).parent(),
                appendArrows: $(this).parent(),
                prevArrow:'<a class="slider-prev"><i class="fal fa-arrow-left"></i></i></a>',
                nextArrow:'<a class="slider-next"><i class="fal fa-arrow-right"></i></i></a>',
                responsive: [
                  {
                    breakpoint: 500,
                    settings: {
                        arrows: false
                    }
                  },
                ]
            });
       });
    }


    $(document).on('change', '.search-select', function(e) {
        var self = $(this);
        var id = self.val();
        window.location.href = "/book-now/search/"+id;
    });


    $(document).on('click', '.show-sub-menu', function() {
        $("#mobile-sub-menu-"+$(this).data('id')).addClass('open');
    });


    $(document).on('click', '.hide-sub-menu', function() {
        $("#mobile-sub-menu-"+$(this).data('id')).removeClass('open');
    });


    if ($('.gs_reveal_fromRight').length > 0) {
        gsap.from(".gs_reveal_fromRight", {
            duration: 2,
            x: 100,
            opacity:0,
            scrollTrigger: {
                trigger: ".gs_reveal_fromRight"
            }
        });
    }

    if ($('.gs_reveal_fromLeft').length > 0) {
        gsap.from(".gs_reveal_fromLeft", {
            duration: 2,
            opacity:0,
            x: -100,
            scrollTrigger: {
                trigger: ".gs_reveal_fromLeft"
            }
        });
    }

    if ($('.gs_reveal_fromBottom').length > 0) {
        gsap.from(".gs_reveal_fromBottom", {
            duration: 2,
            y: -100,
            opacity:0,
            scrollTrigger: {
                trigger: ".gs_reveal_fromBottom"
            }
        });
    }

    if ($('.rotate-hero').length > 0) {
        var heroImages = $(".rotate-hero-image");
        var thisTransform = 0;

        var thisAnimate = () => {
            thisTransform > document.querySelector(".rotate-hero-wrapper").getBoundingClientRect().width / 3 && (thisTransform = 0),
            thisTransform += .9,
            document.querySelector(".rotate-hero-wrapper").style.transform = `translate3d(-${thisTransform}px, 0, 0)`
        }

        var stack = [];

        stack.push(heroImages[0]),
        stack.push(heroImages[1]),
        stack.push(heroImages[2]),
        stack.push(heroImages[3]),
        stack.push(heroImages[4]);

        gsap.to(this.stack, { x: 0, duration: 1.5, ease: "sine", onComplete: gsap.ticker.add(thisAnimate) });
    }

    if ($('.stacked-image-carousel-wrap ').length > 0) {
        const imgs = gsap.utils.toArray('.small-image');
        imgs.forEach(img => {
            gsap.to(img, {
                yPercent: 50,
                scaleX: .90,
                scaleY: .90,
                scrollTrigger: {trigger: img, scrub: 1}
            });
        });
    }


    if ($('.TestimonialsPage').length > 0) {
        $( document ).ready(function() {

            $.ajax({ type: "POST", url: "/testimonials/reviews", dataType: 'json', cache: false })
            .done(function (data) {

                $(".review-pending").hide();
                var allCount = 0;
                var bentonvilleCount = 0;
                var bellaVistaCount = 0;
                var fayettevilleCount = 0;
                var comfortableCount = 0;
                var friendlyCount = 0;
                var professionalCount = 0;
                var procedureCount = 0;
                var knowledgeableCount = 0;

                for (var i = 0; i < data.length; i++) {
                    var stars="";
                    var rating = parseInt(data[i][0]);
                    for (var j = 0; j < rating; j++) {
                        stars+='<i class="fas fa-star"></i>';
                    }
                    $("#review-content").append('<div class="review-item show" data-business="'+data[i][5]+'"><div class="reviewer">'+data[i][2]+'</div><div class="stars">'+stars+'</div><div class="date">'+data[i][3]+'</div><div class="comments">'+data[i][1]+'</div></div>');

                    allCount++;

                    if(data[i][5]=='148155950312747'){
                       bentonvilleCount++;
                    }
                    if(data[i][5]=='148959891294168'){
                       bellaVistaCount++;
                    }
                    if(data[i][5]=='149692703817211'){
                       fayettevilleCount++;
                    }

                    if(data[i][1].includes('comfortable')){
                       comfortableCount++;
                    }
                    if(data[i][1].includes('friendly')){
                       friendlyCount++;
                    }
                    if(data[i][1].includes('professional')){
                       professionalCount++;
                    }
                    if(data[i][1].includes('procedure')){
                       procedureCount++;
                    }
                    if(data[i][1].includes('knowledgeable')){
                       knowledgeableCount++;
                    }


                }

                $("#all-count").html(allCount)
                $("#review-count").html(allCount+" reviews");
                $("#betonville-count").html(bentonvilleCount)
                $("#bellavista-count").html(bellaVistaCount)
                $("#fayetteville-count").html(fayettevilleCount)

                $("#comfortable-count").html(comfortableCount)
                $("#friendly-count").html(friendlyCount)
                $("#professional-count").html(professionalCount)
                $("#procedure-count").html(procedureCount)
                $("#knowledgeable-count").html(knowledgeableCount)




                //0 $review['rating']
                //1 $review['comments']
                //2 $review['reviewer']['nickName']
                //3 $review['reviewDate']
                //4 $review['businessName']
                //5 $review['businessId']
                //6 $review['sourceType']
            });


            $.ajax({ type: "POST", url: "/testimonials/summary", dataType: 'json', cache: false })
            .done(function (data) {
                for (var i = 0; i < data.length; i++) {
                    if (data[i]['sourceAlias']=='google'){
                        $("#review-rating").html(data[i]['avgRating']);
                        // $("#review-count").html(data[i]['reviewCount']+" reviews");
                        var rating = parseInt(data[i]['avgRating']);
                        for (var i = 0; i < rating; i++) {
                            $("#review-stars").append('<i class="fas fa-star">');
                        }
                    }
                }
            });

        });

        $(document).on('click', '.review-filter', function() {
            $('.review-filter').removeClass('active');
            $(this).addClass('active');

            var filterType = $(this).data('type');
            var filterID = $(this).data('id');

            console.log(filterType);
            $('.review-item').removeClass('show');
            $('.review-item').hide();


            if(filterType=='all'){
                $('.review-item').show();
                $('.review-item').addClass('show');
            }
            else if(filterType=='location'){
                $(".review-item").each(function(index, element) {
                    if($(this).data('business')==filterID){
                        $(this).show();
                        $(this).addClass('show');
                    }
                });
            }
            else if(filterType=='string'){
                $(".review-item").each(function(index, element) {
                    if($(this).html().includes(filterID)){
                        $(this).show();
                        $(this).addClass('show');
                    }
                });
            }

        });

    }//End TestimonialsPage


    if ($('.recommended-product-slider').length > 0) {
        $(".recommended-product-slider").each(function(index, element) {
            var slideCount = $(this).data("count");
            if (slideCount>4){
                slideCount=4;
            }

            $(this).slick({
                infinite: true,
                slidesToShow: slideCount,
                slidesToScroll: 1,
                autoplay:true,
                speed: 600,
                dots: false,
                appendArrows: $('.recommended-product-wrap'),
                prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
                nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
                responsive: [
                  {
                    breakpoint: 500,
                    settings: {
                        arrows: false,
                        slidesToShow: 2
                    }
                  },
                ]
            });
       });
    }

    if ($('.VideoPage').length > 0) {
        $(document).on('click', '.video-link', function() {
            var videoLink = $(this).data('link');
            $("#video-iframe").html("");
            $("#video-iframe").append('<iframe width="934" height="700" src="'+videoLink+'" frameborder="0" allowfullscreen> </iframe>');
            $('#videoModal').foundation('open');
        });

        $('#videoModal').on('closed.zf.reveal', function () {
            $("#video-iframe").html("");
         });
    }//End VideoPage


    if ($('.TreatmentsPage').length > 0) {
        $(document).on('click', '.video-link', function() {
            var videoLink = $(this).data('link');
            $("#video-iframe").html("");
            $("#video-iframe").append('<iframe width="934" height="700" src="'+videoLink+'" frameborder="0" allowfullscreen> </iframe>');
            $('#videoModal').foundation('open');
        });

        $('#videoModal').on('closed.zf.reveal', function () {
            $("#video-iframe").html("");
         });
    }//End TreatmentsPage


    if ($('.CareersPage').length > 0) {

        $.ajax({ type: "GET", url: "https://recruiting.paylocity.com/recruiting/v2/api/feed/jobs/9b6d4557-6570-4bd7-a151-530aa73275ed", dataType: 'json', cache: false })
        .done(function (data) {
            for (var i = 0; i < data.jobs.length; i++) {
                let job=data.jobs[i];
                console.log(job);

                let joblocation="";
                if ( 'city' in job["jobLocation"] ){
                    joblocation=job["jobLocation"]["city"];
                }

                $("#career-content").append('<div class="career-item"> <div class="grid-x"> <div class="cell small-12 medium-4"> <a class="" data-open="jobReveal'+job["jobId"]+'"> <div class="career-title">'+job["title"]+'</div><div class="career-dept">'+job["hiringDepartment"]+'</div></a> </div><div class="cell small-12 medium-4 career-info"> <a class="" data-open="jobReveal'+job["jobId"]+'"> <span class="career-location">'+joblocation+'</span> </a> </div><div class="cell small-12 medium-4 text-right"> <div class="career-action" ><a href="'+job["applyUrl"]+'" target="_blank">Apply</a></div><div class="reveal career-reveal large" id="jobReveal'+job["jobId"]+'" data-reveal style="background-color:#fff;" data-animation-in="fade-in" data-animation-out="fade-out"> <a href="javacript:;" class="career-close-button" data-close >&times;</a> <div class="grid-x"> <div class="cell small-12 medium-6"> <h3 class="job-title">'+job["title"]+'</h3> <div class="job-dept">Dept: '+job["hiringDepartment"]+'</div></div><div class="cell small-12 medium-6"> <div class="job-location">'+joblocation+'</div><div class="job-date">'+formatDate(job["publishedDate"])+'</div></div></div><div class="grid-x job-info"> <div class="cell small-12"><h3>Description</h3>'+job["description"]+'</div></div><div class="grid-x job-info"> <div class="cell small-12"><h3>Requirements</h3>'+job["requirements"]+'</div></div></div></div></div></div>');
            }

            $(".reveal").each(function() {
                var r = new Foundation.Reveal($(this));
            });

        });

        function formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        }//End formatDate

    }//End CareersPage

    if ($('.BrandLandingPage').length > 0) {
        var loadingScreen = $('#loading-screen');
        setTimeout(function() {
            loadingScreen.fadeOut(500);
        }, 4000);

        $(document).on('click', '.btn-show-services', function(e) {
            $(this).parent().addClass('open');
            e.stopPropagation();
            return false;
        });
        $(document).on('click', '.btn-close-services', function(e) {
            $(this).parent().removeClass('open');
            e.stopPropagation();
            return false;
        });
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    }
      
    // if(!getCookie('premierlanding')) {
    //     window.location = "/premier-landing";
    // }

    // $(document).on("click", ".btn-premier-path", function(e) {
    //     setCookie('premierlanding','1',120);
    //     return false;
    // });
      
});
